<template>
  <div class="modal fade" id="reminder-status" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent">
          <div class="block-header" :class="headerColor">
            <h3 class="block-title">Change status</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" @click.prevent="clearData" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{errorMsg}}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group">
              <label>Change status</label>
              <select v-model="action" class="form-control form-control-alt">
                <option :value="statusvalue" :key="statusvalue" v-for='(statusName, statusvalue) in getAvailableStatus'>{{statusName}}</option>
              </select>
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click="updateStatus" :disabled="showModalLoader">
              <div><span>Update</span></div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { helper } from '@/helper.js';
import { mapActions } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
Vue.use(VueSpinners);

export default{
  name: 'UpdateReminderStatus',
  data() {
    return {
      showModalLoader: false,
      errorMsg: '',
      action: 'complete',
      selectedId: [],
      callback: null,
      availableStatus: {
        'active': { 'complete': 'Complete', 'inactive': 'Deactivate', 'late': 'Late' },
        'inactive': { 'complete': 'Complete', 'active': 'Activate', 'late': 'Late' },
        'late': { 'complete': 'Complete', 'inactive': 'Deactivated' }
      },
      currentStatus: 'active',
      headerColor: 'bg-warning'
    };
  },
  components: {
    HashLoader
  },
  computed: {
    getAvailableStatus() {
      return this.availableStatus[this.currentStatus];
    }
  },
  methods: {
    ...mapActions('library', ['getRecentNotificationList', 'getRecentNotificationCount']),
    updateStatus() {
      let vm = this;
      vm.showModalLoader = true;
      helper.sendPostRequest('/todo/update', {
        action: 'changeStatus',
        selectedId: vm.selectedId,
        status: vm.action
      }).then((data) => {
        if (data.status === 'success') {
          jQuery('#reminder-status').modal('hide');
          vm.clearData();
          vm.getRecentNotificationList();
          vm.getRecentNotificationCount();
          vm.$emit('showSuccessMsg', data.message);
          vm.$emit('refreshList', true);
        } else {
          vm.errorMsg = data.message;
        }
      }).catch(function() {
        vm.errorMsg = 'Unable to process your request.';
      });
      vm.showModalLoader = false;
    },
    clearData() {
      this.showModalLoader = false;
      this.errorMsg = '';
      this.action = 'complete';
      this.selectedId = [];
      if (this.callback !== null) {
        this.callback();
      }
    },
    setSelectedId(data) {
      this.selectedId = data;
    },
    setCallback(callback) {
      this.callback = callback;
    },
    setCurrentStatus(status) {
      this.currentStatus = status;
    },
    setHeaderColor(color) {
      this.headerColor = color;
    }
  }
};
</script>

<style scoped>
#reminder-status .block {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// source/components/modals/UpdateReminderStatus.vue